module.exports = __webpack_public_path__ + "static/media/44475022_2199895523418960_6484300886288891904_o.0771f325.jpg";